import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Bathtub02Icon } from '@hugeicons/core-free-icons';

function Bathroom(props) {
    const fill = props.fill;
    const className = props.className;
    const size = props.size;
    return (
        <HugeiconsIcon
            icon={Bathtub02Icon}
            color={fill}
            className={className}
            size={size}
        />
    )
}

export default Bathroom;